import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Tooltip, OverlayTrigger } from 'react-bootstrap';

const ButtonOverlayIcon = ({
  cmpId = 'tooltip',
  tooltipLabel = 'Tooltip',
  iconName,
  iconSize,
  bsClass,
  bsSize = 'xsmall',
  bsStyle = 'primary',
  onClick,
  className
}) => {
  const tooltip = <Tooltip id={cmpId}>{tooltipLabel}</Tooltip>;

  return (
    <OverlayTrigger
      overlay={tooltip}
      placement="top"
    >
      <Button
        className={className}
        bsClass={bsClass}
        bsSize={bsSize}
        bsStyle={bsStyle}
        onClick={onClick}
      >
        <FontAwesomeIcon
          icon={iconName}
          size={iconSize}
        />
      </Button>
    </OverlayTrigger>
  );
};

export default ButtonOverlayIcon;
